import clsx from 'clsx';
import { FC, useCallback, useRef } from 'react';
import useClickAway from '../../hooks/clickaway';
import { IDropdown } from '../../types';
import DropdownItem from './item';
import DropdownMenu from './menu';
import DropdownTrigger from './trigger';

interface IDropdownExtended {
  Trigger: typeof DropdownTrigger;
  Menu: typeof DropdownMenu;
  Item: typeof DropdownItem;
}

const Dropdown: FC<IDropdown & { onClickAway?: () => void }> & IDropdownExtended = props => {
  const { isRight = false, isOpen, setIsOpen, children, onClickAway, ...rest } = props;

  const ref = useRef(null);

  const handleClickAway = useCallback(() => {
    if (!isOpen) return;

    setIsOpen(false);
    onClickAway?.();
  }, [isOpen, setIsOpen, onClickAway]);

  // listen for clicks outside div to close dropdown
  useClickAway(ref, handleClickAway);

  const isRightClass = isRight ? 'is-right' : '';

  return (
    <div ref={ref} className={clsx('dropdown', isRightClass, { 'is-active': isOpen })} {...rest}>
      {children}
    </div>
  );
};

Dropdown.Trigger = DropdownTrigger;
Dropdown.Menu = DropdownMenu;
Dropdown.Item = DropdownItem;

export default Dropdown;
